import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ProfileHeader = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{
          fontWeight: 700,
          color: "text.primary",
          fontSize: { xs: "1.8rem", sm: "2.125rem" },
        }}
      >
        {t("Dashboard_profile.header.title")}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {t("Dashboard_profile.header.subtitle")}
      </Typography>
    </Box>
  );
};

export default ProfileHeader;
